import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Stack, Typography } from '@mui/material';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { ModalComponent, ModalConfig } from 'new/routes/RouterManager';
import styles from './ModalRequestAccess.module.scss';
import { Nexset } from 'new/entities/Nexset';
import { useModals } from 'new/hooks/useModals';
import { requestDomainItemAccess } from 'js/actions';
import { showAlert } from 'new/stores/showAlert/action';

interface ModalRequestAccessProps {
  item: Nexset;
  domainId: number;
}

export const ModalRequestAccess: ModalComponent = (
  props: ModalRequestAccessProps & ModalOutProps,
) => {
  const { item, domainId, setModalActions } = props;
  const { closeModal } = useModals();
  const dispatch = useDispatch();

  const handleSubmitRequest = () => {
    dispatch(requestDomainItemAccess(domainId, item?.id)).then(() => {
      dispatch(
        showAlert({
          title: 'Data Product Access Request sent successfully',
          severity: 'success',
        }),
      );
      closeModal(ModalRequestAccess.modalConfig.name);
    });
  };

  useEffect(() => {
    setModalActions({
      ok: {
        text: 'Send Request',
        onClick: handleSubmitRequest,
      },
    });
  }, []);

  return (
    <Stack className={styles.modalRequestContainer}>
      <Stack direction="row" gap="12px">
        <Typography>
          You will get access to Nexset - {item?.name} (Nexset ID: {item?.id}) once a Data Custodian
          approves your request.
        </Typography>
      </Stack>
    </Stack>
  );
};

ModalRequestAccess.modalConfig = {
  name: 'ModalRequestAccess',
  title: 'Request Access',
  fullWidth: true,
  maxWidth: 'sm',
} as ModalConfig;
